export default {
    init() {
        jQuery('#btnEnquireAnimal').click((e) => {
            e.stopPropagation();

            $([document.documentElement, document.body]).animate({
                scrollTop: $("#learnMore").offset().top - 140
            }, 2000); 
        });

        jQuery(document).ready(function($) {
            $('#gallery-1').royalSlider({
              fullscreen: {
                enabled: true,
                nativeFS: true
              },
              controlNavigation: 'thumbnails',
              autoScaleSlider: true, 
              autoScaleSliderWidth: 960,     
              autoScaleSliderHeight: 850,
              loop: false,
              imageScaleMode: 'fit-if-smaller',
              navigateByClick: true,
              numImagesToPreload:2,
              arrowsNav:true,
              arrowsNavAutoHide: true,
              arrowsNavHideOnTouch: true,
              keyboardNavEnabled: true,
              fadeinLoadedSlide: true,
              globalCaption: true,
              globalCaptionInside: false,
              thumbs: {
                appendSpan: true,
                firstMargin: true,
                marginTop: 25,
                paddingBottom: 4,
                spacing: 25,
              },
              video: {
                autoHideArrows:true,
                autoHideControlNav:false,
                autoHideBlocks: true
              }, 
            });
          });

        jQuery(window).load(function() {
            jQuery('.single-animals #state').select2({
                containerCssClass : "customdropdown",
                placeholder: "State*",
                data: [
                    {
                        "text":"New South Wales",
                        "id":"NSW"
                    },
                    {
                        "text":"Victoria",
                        "id":"VIC"
                    },
                    {
                        "text":"Queensland",
                        "id":"QLD"
                    },
                    {
                        "text":"Tasmania",
                        "id":"TAS"
                    },
                    {
                        "text":"South Australia",
                        "id":"SA"
                    },
                    {
                        "text":"Western Australia",
                        "id":"WA"
                    },
                    {
                        "text":"Northern Territory",
                        "id":"NT"
                    },
                    {
                        "text":"Australian Capital Territory",
                        "id":"ACT"
                    }
                ]
            });
        });
        

        jQuery('#animalsSingle .locations').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Select a Location"
        });

        jQuery('#animalsSingle .age').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Select a Age"
        });

        jQuery('#animalsSingle .gender').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Select a Gender"
        });

        jQuery('#animalsSingle .otheranimals').select2({
            minimumResultsForSearch: Infinity,
            containerCssClass : "customdropdown",
            placeholder: "Search Animals"
        });

        
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  



// WEBPACK FOOTER //
// ./scripts/routes/templateSingleAnimal.js